import React from "react";
import { useState, useEffect } from "react";

export const Navigation = (props) => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Navegación</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            <picture>
              <source
                media="(max-width: 767px)"
                srcset="../img/logo.png"
                className="logo-navbar"
              />
              <source
                media="(min-width: 768px) and (max-width: 990px)"
                srcset="../img/logo_small.png"
                className="logo-navbar"
              />
              <img
                src="../img/logo.png"
                alt="GIRO SOLUTIONS"
                className="logo-navbar"
              />
            </picture>
          </a>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a
                href="#features"
                className="page-scroll"
                data-toggle={width < 765 ? "collapse" : null}
                data-target={
                  width < 765 ? "#bs-example-navbar-collapse-1" : null
                }
              >
                QUE ofrecemos
              </a>
            </li>
            <li>
              <a
                href="#about"
                className="page-scroll"
                data-toggle={width < 765 ? "collapse" : null}
                data-target={
                  width < 765 ? "#bs-example-navbar-collapse-1" : null
                }
              >
                Sobre nosotros
              </a>
            </li>
            <li>
              <a
                href="#services"
                className="page-scroll"
                data-toggle={width < 765 ? "collapse" : null}
                data-target={
                  width < 765 ? "#bs-example-navbar-collapse-1" : null
                }
              >
                servicios
              </a>
            </li>
            {/* <li>
              <a href="#portfolio" className="page-scroll">
                Gallery
              </a>
            </li>
            <li>
              <a href="#testimonials" className="page-scroll">
                Testimonials
              </a>
            </li>*/}
            <li>
              <a
                href="#team"
                className="page-scroll"
                data-toggle={width < 765 ? "collapse" : null}
                data-target={
                  width < 765 ? "#bs-example-navbar-collapse-1" : null
                }
              >
                equipo
              </a>
            </li>
            <li>
              <a
                href="#contact"
                className="page-scroll"
                data-toggle={width < 765 ? "collapse" : null}
                data-target={
                  width < 765 ? "#bs-example-navbar-collapse-1" : null
                }
              >
                contacto
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
